// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-spr-intervene[data-v-6c97ace7]{background-color:#c0504d}.bg-spr-watch[data-v-6c97ace7]{background-color:#f79646}.bg-spr-reinforce[data-v-6c97ace7]{background-color:#00b050}.bg-spr-model[data-v-6c97ace7]{background-color:#0070c0}", ""]);
// Exports
module.exports = exports;
